import React from "react";
import { Table } from "semantic-ui-react";
import _ from "lodash";
import { getDate, getDobDate } from "../../common/DisplayDate";
import getSsn from "../../common/Ssn";
import Address from "../../searchresults/Address";
import getPersonName from "../../common/Name";

const getMotorSubRecordDetails = (
  record,
  recordType,
  titleInfo,
  props,
  rowKeySuffix
) => {
  const rows = [];
  rows.push(
    <Table.Row key={`${recordType}_top_title_row_${rowKeySuffix}`}>
      <Table.HeaderCell
        colSpan={4}
        className={"report-sub-section-header text-center"}
      >
        {recordType} Details
      </Table.HeaderCell>
    </Table.Row>
  );

  rows.push(
    <Table.Row key={`${recordType}_title_row_${rowKeySuffix}`}>
      <Table.Cell
        colSpan={4}
        className={"report-sub-sub-section-header text-center"}
      >
        {recordType}
      </Table.Cell>
    </Table.Row>
  );

  const name = _.get(record, "name[0]");
  if (name !== undefined) {
    rows.push(
      <Table.Row key={`${recordType}_name_row_${rowKeySuffix}`}>
        <Table.Cell>Name:</Table.Cell>
        <Table.Cell>
          {getPersonName(
            _.get(name, "first[0]._", ""),
            "",
            _.get(name, "last[0]._", ""),
            props
          )}
        </Table.Cell>
        <Table.Cell>Gender:</Table.Cell>
        <Table.Cell>{_.get(record, "gender[0]._", "")}</Table.Cell>
      </Table.Row>
    );
  }

  const businessName = _.get(record, "businessName[0]");
  if (businessName !== undefined) {
    rows.push(
      <Table.Row key={`${recordType}_business_row_${rowKeySuffix}`}>
        <Table.Cell>Business Name:</Table.Cell>
        <Table.Cell>{_.get(record, "businessName[0]._", "")}</Table.Cell>
        <Table.Cell>Business ID:</Table.Cell>
        <Table.Cell>{_.get(record, "businessId[0]._", "")}</Table.Cell>
      </Table.Row>
    );
  }

  const appendSSN = _.get(record, "appendSSN[0]");
  if (appendSSN !== undefined) {
    rows.push(
      <Table.Row key={`${recordType}_ssn_row_${rowKeySuffix}`}>
        <Table.Cell>SSN:</Table.Cell>
        <Table.Cell>
          {getSsn(_.get(record, "appendSSN[0]._", ""), props)}
        </Table.Cell>
        <Table.Cell>DOB:</Table.Cell>
        <Table.Cell>
          {getDobDate(_.get(record, "DOB[0]"), {
            userAccount: props.userAccount,
          })}
        </Table.Cell>
      </Table.Row>
    );
  } else {
    const dob = _.get(record, "DOB[0]");
    if (dob !== undefined) {
      rows.push(
        <Table.Row key={`${recordType}_dob_row_${rowKeySuffix}`}>
          <Table.Cell>DOB:</Table.Cell>
          <Table.Cell>
            {getDobDate(_.get(record, "DOB[0]"), {
              userAccount: props.userAccount,
            })}
          </Table.Cell>
          <Table.Cell />
          <Table.Cell />
        </Table.Row>
      );
    }
  }

  const address = _.get(record, "address[0]");
  if (address !== undefined) {
    rows.push(
      <Table.Row key={`${recordType}_address_row_${rowKeySuffix}`}>
        <Table.Cell>Address:</Table.Cell>
        <Table.Cell colSpan={3}>
          <Address addressNode={address} {...props} />
        </Table.Cell>
      </Table.Row>
    );
  }

  if (titleInfo !== undefined) {
    rows.push(
      <Table.Row key={`${recordType}_title_info_header_row_${rowKeySuffix}`}>
        <Table.Cell colSpan={100}>Title Information</Table.Cell>
      </Table.Row>
    );
    rows.push(
      <Table.Row key={`${recordType}_title_info_detail_row_${rowKeySuffix}`}>
        <Table.Cell>Title Number:</Table.Cell>
        <Table.Cell>{_.get(titleInfo, "number[0]._", "")}</Table.Cell>
        <Table.Cell>Issue Date:</Table.Cell>
        <Table.Cell>
          {getDate(_.get(titleInfo, "earliestIssueDate[0]"))}
        </Table.Cell>
      </Table.Row>
    );
  }
  return rows;
};

export default getMotorSubRecordDetails;



// WEBPACK FOOTER //
// ./src/components/reports/Platinum/MotorSubRecordDetails.js